<template>
    <div class="help">
        <div class="container">
            <h1 class="title">About us</h1>

            <div class="overview">
                <div><a href="https://www.airc.aist.go.jp/en/ibrt/">Intelligent Bioinformatics Research Team</a></div>
                <div><a href="https://www.airc.aist.go.jp/en/">Artificial Intelligence Research Center (AIRC)</a></div>
                <div><a href="https://www.aist.go.jp/index_en.html">National Institute of Advanced Industrial Science and Technology (AIST)</a></div>
            </div>

        </div>
    </div>


</template>

<script>

export default {
    name: 'Help',
    components: {
    },
    data: function() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped>
.container {
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    font-size: 18px;
}

.block {
    padding: 30px;
    border: solid 1px;
    margin-top: 100px;
    margin-bottom: 100px;
}

.description {
    text-align: left;
}

.capture {
    text-aling:center;
}

.capture img {
    margin-top: 30px;
    margin-bottom: 30px;
    margin-left: 20%;
    margin-right: auto;
    width: 60%;
}
</style>